import React from "react"
import Dropdown from "react-bootstrap/lib/Dropdown"
import DropdownToggle from "react-bootstrap/lib/DropdownToggle"
import MenuItem from "react-bootstrap/lib/MenuItem"
import styled from "styled-components"
import { appStrings } from "../common/strings/app_strings"
import ZapierLogo from "../images/zapier-logo-transparent.png"
import { canPushTimeRecordReportToZapier } from "../util/webhook_subscriptions_utils"
import { makeToast } from "../util/toast_util"
import { PUSH_REPORT_TO_ZAPIER } from "../common/constants/app_consts"

const {
    exportString,
    downloadCsvString,
    pushToZapierString,
} = appStrings.reportModal

const handleZapierMessage = () => {
    const msg = (
        <div>
            <p>Hello!</p>
            <p>
                Using Zapier, you can push Shoutbase time records and report
                data to almost any other cloud service! You don’t currently have
                an integration set up to push to Zapier, so go{" "}
                <a target="_blank" href={PUSH_REPORT_TO_ZAPIER}>
                    HERE
                </a>{" "}
                to learn how to set one up.
            </p>
        </div>
    )
    const ind = "primary"
    const action = {
        text: "LEARN MORE",
        onClick: () => {
            var win = window.open(PUSH_REPORT_TO_ZAPIER, "popUpWindow")
            win.focus()
        },
    }

    makeToast(msg, ind, action)
}

export const ExportReportSelector = ({
    exportParams,
    downloadCsv,
    pushReportToZapier,
    webhookSubscriptions,
}) => {
    const canPushReportToZapier = canPushTimeRecordReportToZapier(
        webhookSubscriptions,
    )

    const handleExport = action => {
        switch (action) {
            case "DOWNLOAD_CSV":
                downloadCsv(exportParams)
                break
            case "PUSH_TO_ZAPIER":
                if (canPushReportToZapier) {
                    pushReportToZapier(exportParams)
                } else {
                    handleZapierMessage()
                }
                break
            default:
                console.log("NOOP: This should not be reachable") // eslint-disable-line no-console
                return
        }
    }

    return (
        <ExportDropdown>
            <Dropdown id="export-dropdown" onSelect={handleExport}>
                <DropdownToggle className="btn-export" noCaret>
                    <p>{exportString}</p>
                    <i className="fa fa-chevron-down" aria-hidden="true" />
                </DropdownToggle>
                <Dropdown.Menu>
                    <MenuItem className="menu-item" eventKey={"DOWNLOAD_CSV"}>
                        <div className="icon-wrapper">
                            <i className="fa fa-download menu-item-icon"></i>
                        </div>
                        <p>{downloadCsvString}</p>
                    </MenuItem>
                    <MenuItem className="menu-item" eventKey={"PUSH_TO_ZAPIER"}>
                        <div className="icon-wrapper">
                            <img
                                className="menu-item-icon"
                                src={ZapierLogo}
                                alt="Zapier Icon"
                            />
                        </div>
                        <p>{pushToZapierString}</p>
                    </MenuItem>
                </Dropdown.Menu>
            </Dropdown>
        </ExportDropdown>
    )
}

//styles
const ExportDropdown = styled.div`
    #export-dropdown {
        border: 1px solid #dee0e3;
        font-size: 12px;
        font-weight: 600;
        background-color: rgba(255, 255, 255, 0);
        margin-left: 0;
        text-transform: uppercase;
        display: flex;
        align-items: center;

        p {
            margin: 0;
            line-height: normal;
        }
    }

    #export-dropdown:hover {
        background-color: whitesmoke;
        border-color: #ced0d4;
    }

    .menu-item {
        .icon-wrapper {
            display: flex;
            justify-content: flex-start;
            width: 25px;
        }

        a {
            display: flex;
            align-items: center;
            padding: 5px 10px;

            p {
                margin: 0;
            }
        }
    }

    .menu-item-icon {
        font-size: 14px;
        color: #3aaafc;
        width: 14px;
        height: 14px;
    }

    .fa-chevron-down:before {
        color: #a8a9aa !important;
        margin: 0 0 2px 10px;
        font-size: 12px;
    }

    & .dropdown-menu > li > a:hover {
        background-color: whitesmoke;
    }

    i:before {
        padding-left: 1px;
    }
`



// WEBPACK FOOTER //
// ./src/components/export_report_selector.jsx